'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addMonths;


// WEBPACK FOOTER //
// ./~/sugar-date/date/addMonths.js